// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1AwsEndpointConnectionState = {
  AwsEndpointConnectionStateAccepted: 'accepted',
  AwsEndpointConnectionStatePending: 'pending',
  AwsEndpointConnectionStatePendingAcceptance: 'pendingAcceptance',
  AwsEndpointConnectionStateRejected: 'rejected',
  AwsEndpointConnectionStateAvailable: 'available',
  AwsEndpointConnectionStateDeleting: 'deleting',
  AwsEndpointConnectionStateDeleted: 'deleted',
  AwsEndpointConnectionStateFailed: 'failed',
  AwsEndpointConnectionStateExpired: 'expired',
} as const;
export type V1AwsEndpointConnectionState =
  (typeof V1AwsEndpointConnectionState)[keyof typeof V1AwsEndpointConnectionState];

export function instanceOfV1AwsEndpointConnectionState(value: any): boolean {
  for (const key in V1AwsEndpointConnectionState) {
    if (
      Object.prototype.hasOwnProperty.call(V1AwsEndpointConnectionState, key)
    ) {
      if (
        V1AwsEndpointConnectionState[
          key as keyof typeof V1AwsEndpointConnectionState
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function V1AwsEndpointConnectionStateFromJSON(
  json: any,
): V1AwsEndpointConnectionState {
  return V1AwsEndpointConnectionStateFromJSONTyped(json, false);
}

export function V1AwsEndpointConnectionStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1AwsEndpointConnectionState {
  return json as V1AwsEndpointConnectionState;
}

export function V1AwsEndpointConnectionStateToJSON(
  value?: V1AwsEndpointConnectionState | null,
): any {
  return value as any;
}

export function V1AwsEndpointConnectionStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V1AwsEndpointConnectionState {
  return value as V1AwsEndpointConnectionState;
}
